import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav';

function LogoutButton() {
    const [buttonClicked, clickButton] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        if (buttonClicked) {
            fetch("https://mv.cylee.xyz/logoutUser").then(response => {
                if(!response.ok) {
                    alert("Logout failed")
                } else {
                    navigate("/")
                }
            })
        }
    })

    const logoutClickHandler = () => {
        clickButton(true)
    }
    
    return(
        <Nav.Item onClick={logoutClickHandler}>
            Logout
        </Nav.Item>
    )
}

export default LogoutButton